export const ROLES = {
  SUPER_ADMIN: 'Super Admin',
  ADMIN: 'Admin',
  MODERATOR: 'Moderator',
  SUPPORT: 'Support',
  FINANCE: 'Finance',
  MARKETING: 'Marketing',
  CONTENT_MANAGER: 'Content Manager',
};

export const PERMISSIONS = {
  VIEW: 'view',
  CREATE: 'create',
  EDIT: 'edit',
  DELETE: 'delete',
  APPROVE: 'approve',
  REJECT: 'reject',
  EXPORT: 'export',
};

export const ROLE_PERMISSIONS_MATRIX = {
  [ROLES.SUPER_ADMIN]: Object.values(PERMISSIONS),
  [ROLES.ADMIN]: [PERMISSIONS.VIEW, PERMISSIONS.CREATE, PERMISSIONS.EDIT, PERMISSIONS.APPROVE, PERMISSIONS.REJECT, PERMISSIONS.EXPORT],
  [ROLES.MODERATOR]: [PERMISSIONS.VIEW, PERMISSIONS.EDIT, PERMISSIONS.APPROVE, PERMISSIONS.REJECT],
  [ROLES.SUPPORT]: [PERMISSIONS.VIEW, PERMISSIONS.EDIT],
  [ROLES.FINANCE]: [PERMISSIONS.VIEW, PERMISSIONS.EXPORT],
  [ROLES.MARKETING]: [PERMISSIONS.VIEW, PERMISSIONS.CREATE, PERMISSIONS.EDIT, PERMISSIONS.EXPORT],
  [ROLES.CONTENT_MANAGER]: [PERMISSIONS.VIEW, PERMISSIONS.CREATE, PERMISSIONS.EDIT, PERMISSIONS.DELETE],
};
